/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CornersIn(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M152,96V48a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8.00038,8.00038,0,0,1,208,104H160A8.00008,8.00008,0,0,1,152,96ZM96,152H48a8.00038,8.00038,0,0,0-5.65723,13.65674l48,48A8.0001,8.0001,0,0,0,104,208V160A8.00008,8.00008,0,0,0,96,152ZM99.06152,40.60889a7.99989,7.99989,0,0,0-8.71875,1.73437l-48,48A8.00038,8.00038,0,0,0,48,104H96a8.00008,8.00008,0,0,0,8-8V48A8.00015,8.00015,0,0,0,99.06152,40.60889ZM208,152H160a8.00008,8.00008,0,0,0-8,8v48a8.00018,8.00018,0,0,0,13.65723,5.65674l48-48A8.00038,8.00038,0,0,0,208,152Z" />
    </Svg>
  );
}

export default CornersIn;
